/*global angular */
'use strict';

angular.module('MrDWebApp').controller('AdminErrorCtrl', function ($scope, $previousState) {
  $scope._rc.bodyClass = 'html-white';
  $previousState.memo('caller');
});
